import React from 'react';
import { Select } from 'components';
import { useSupplierSelectListQuery } from 'api';
import { FMGSelectProps } from 'components/antd/select';

export const SupplierSelect: React.FC<FMGSelectProps> = React.memo((props) => {
  const { data = [] } = useSupplierSelectListQuery();

  return (
    <Select
      options={data}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
